import LeadCapture from '@/components/common/LeadCapture';
import CourseDescriptionContext from '@/context/CourseDescriptionContext';
import { LeadCaptureEnquiryType, LeadCaptureType, ModalType } from '@/interfaces/leadCapture.enum';
import { DEGREE_ADMISSION_STATUS } from '@/utils/common/common.constants';
import {
  getAdmissionStatus,
  getRegistrationEndDateInFormat,
} from '@/utils/onlineDegreeListing/common';
import { Button, Container, Typography } from '@pwskills/rachnaui';
import { useContext, useState } from 'react';
import { useUTMParameters } from '@pwskills/rachnaui/hooks';
import { GAevent } from '@/utils/firebase.utils';
import { useRouter } from 'next/router';
import { sendSkFormStartedEvent } from '@/utils/GAEventFunction';

interface IRegistration {
  startDate: string;
  endDate: string;
}

const ElevateYourCareerSection = () => {
  const [openModal, setOpenModal] = useState<boolean>(false);
  const { courseDetails } = useContext(CourseDescriptionContext);
  const registration = {
    startDate: courseDetails?.registrationStartDate,
    endDate: courseDetails?.registrationEndDate,
  };
  const router = useRouter();
  const utmQuery = useUTMParameters();
  const sendGAEvent = (eventName: string) => {
    const GAEventData = {
      click_cta: 'Get Connected Now',
      page_ref: router?.query?.from || '',
      utm_source: utmQuery?.utm_source || '',
      utm_medium: utmQuery?.utm_medium || '',
      utm_campaign: utmQuery?.utm_campaign || '',
    };
    GAevent(eventName, GAEventData);
  };

  const getRegistrationEndDateText = () => {
    const admissionStatus = getAdmissionStatus(registration as IRegistration);

    let admissionStatusText = 'Closes';

    switch (admissionStatus) {
      case DEGREE_ADMISSION_STATUS.BEGIN_SOON:
        admissionStatusText = 'Closes';
        break;

      case DEGREE_ADMISSION_STATUS.OPEN:
        admissionStatusText = 'Closes';

        break;

      case DEGREE_ADMISSION_STATUS.CLOSING_SOON:
        admissionStatusText = 'Closes';

        break;

      case DEGREE_ADMISSION_STATUS.CLOSED:
        admissionStatusText = 'Closed';
        break;

      default:
        break;
    }

    return admissionStatusText;
  };

  return (
    <Container
      id="elevate-your-career-section"
      className="py-0 medium:!py-8 large:!py-[40px] flex flex-col gap-6 medium:gap-9 px-0 medium:!px-8 large:!px-20"
    >
      <div className="py-6 px-[60px] medium:!py-[56px] flex flex-col gap-6 items-center bg-gradient-to-r from-[#F3EAF6] from-0% to-[#F9ECEB] to-100% relative medium:rounded-2xl">
        <div className="flex flex-col items-center">
          <Typography
            variant="bold"
            component="h3"
            className=" text-gray-850 !text-[20px] !leading-[30px] medium:!text-[24px] medium:!leading-9 text-center"
          >
            Elevate your career with this programme
          </Typography>
          <Typography
            variant="medium"
            component="h3"
            className=" text-gray-850 !text-[14px] !leading-[22px] font-nunito"
          >
            Start your journey to success with us!
          </Typography>
        </div>
        <div className="flex gap-2 justify-center">
          <img src="/images/coursesCard/calendar.svg" alt="calender" />

          <Typography
            variant="bold"
            component="h3"
            className=" text-gray-850 !text-[16px] !leading-[24px] font-nunito  whitespace-nowrap"
          >
            Admission {getRegistrationEndDateText()} on -
            {getRegistrationEndDateInFormat(registration as IRegistration)}
          </Typography>
        </div>
        <Button
          size="medium"
          className="!px-5 !py-2"
          onClick={() => {
            setOpenModal(true);
            sendGAEvent('sk_form_start');
            sendSkFormStartedEvent({
              page_path: router.pathname,
              page_referrer_name: 'online_degree',
              page_referrer_cta: 'Apply now',
              page_referrer_widget_name: 'elevate_your_career_section',
              form_id: 'lead_form_online_degree_apply_now',
              form_name: 'Online Degree Lead Form',
              form_type: 'lead',
              form_location: 'online_degree',
              form_time_fill_sec: 0,
              course_batch_name: courseDetails?.title || courseDetails?.name || '',
              course_batch_slug: courseDetails?.slug || '',
              course_batch_category: courseDetails?.categoryDetails?.title || '',
              course_batch_id: courseDetails?._id || '',
              course_batch_cohort_id:
                (typeof courseDetails?.cohortId === 'string'
                  ? courseDetails?.cohortId
                  : (courseDetails?.cohortId as { _id?: string })?._id) ||
                courseDetails?.batchCategoryId ||
                courseDetails?.categoryDetails?._id ||
                '',
              price: Number(courseDetails?.pricing?.IN || courseDetails?.pricing?.US || 0),
              discount_percentage: Number(courseDetails?.pricing?.discount || 0),
              is_free: !!courseDetails?.pricing?.isFree,
            });
          }}
        >
          Apply now
        </Button>

        <img
          src="/images/degreeDescription/elevateYourCareer/person.svg"
          alt="calender"
          className="medium:h-[160px] large:h-auto large:w-[252px] absolute bottom-0 medium:left-[12px] large:left-[34px] hidden medium:!block"
        />
        <img
          src="/images/degreeDescription/elevateYourCareer/degreeCap.gif"
          alt="degreeCap"
          className="absolute medium:w-[80px] large:w-[100px] rotate-[-20deg] medium:left-[22px] large:left-[48px] medium:top-[89px] large:top-[28px] hidden medium:!block"
        />
      </div>

      {openModal && (
        <LeadCapture
          leadCaptureType={LeadCaptureType.MODAL}
          modalType={ModalType.ONLINE_DEGREE}
          modelOpen={openModal}
          setModelOpen={setOpenModal}
          buttonText="Get Connected"
          img="/images/bhilai-lead-capture-modal-pic.svg"
          msgLineOne="We Got Your Response."
          msgLineTwo="Our Counsellor will reach out soon"
          type="ConnectWithCounsellor"
          enquiryType={LeadCaptureEnquiryType.ONLINE_DEGREE_APPLY_NOW}
          enquiryTypeNPF="Online Degree_applynow" // check
          pageName="online_degree"
          sourceName="online_degree_premium_apply_now"
        />
      )}
    </Container>
  );
};

export default ElevateYourCareerSection;
